export const notificationPushTypes = {
    ADD_NOTIFICATION_COUNT: "ADD_DEVICE_TOKEN",
    ADD_NOTIFICATION_DATA: "ADD_NOTIFICATION_DATA",
    ADD_USER_INFORMATION: "ADD_USER_INFORMATION",
    ADD_OBJECT_INFORMATION: "ADD_OBJECT_INFORMATION"
};